package org.hs_soft.runmynesto.pages.home.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.pages.components.AnimatedVisibilityBox
import org.hs_soft.runmynesto.pages.components.dialog.dialog.DataAssistantAIDialog
import org.hs_soft.runmynesto.pages.home.Home
import org.hs_soft.runmynesto.pages.home.mvi.HomeEvent
import org.hs_soft.runmynesto.pages.home.mvi.HomeState
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component.ProductTabDataAssistantContent
import org.jetbrains.compose.web.css.*


@Composable
fun HomeDialogs(
    state: HomeState,
    windowSizeMode: WindowSizeModeEnum,
    event: (HomeEvent) -> Unit
) {
    AnimatedVisibilityBox(visible = state.showDataAssistantIcon && !state.showDataAssistantDialog) {
        ProductTabDataAssistantContent(
            info = state.virtualCardInfo,
            onChatButtonClick = { email ->
                event(HomeEvent.SetDataAssistantDialogStatus(email,true))
            },
            onCloseDataAssistantButtonClick = { event(HomeEvent.SetDataAssistantIconStatus(false)) }
        )
    }
    if (!state.showDataAssistantIcon && !state.showDataAssistantDialog) {
        Image(
            src = Res.PathIcon.restoMateDropDownIcon,
            modifier = Modifier
                .size(Dimen.semiLargeIconSize2.px)
                .margin(right=Dimen.normalPadding)
                .right(-(Dimen.semiNormalPadding))
                .bottom(Dimen.highLargePadding + Dimen.dataAssistantButtonSize.px)
                .zIndex(Constants.ZIndex.largeZIndex)
                .width(Dimen.semiLargeIconSize2.px)
                .height(Dimen.semiLargeIconSize2.px)
                .backgroundSize(BackgroundSize.Contain)
                .backgroundRepeat(BackgroundRepeat.NoRepeat)
                .position(Position.Fixed)
                .cursor(Cursor.Pointer)
                .onClick {
                    event(HomeEvent.SetDataAssistantIconStatus(true))
                }
        )
    }

    if (state.showDataAssistantDialog){
        DataAssistantAIDialog(
            windowSizeMode=state.windowSizeMode,
            speechLanguage = state.speechLanguage,
            loading = state.isDataAssistantAIGeneratorLoading,
            databaseLoading = state.isDataAssistantDatabaseLoading,
            question = state.answerAIGeneratorQuestion,
            messageHistory = state.messageHistory,
            sendIsClickable = state.sendQuestionButtonIsClickable,
            info = state.virtualCardInfo,
            onBackgroundClick = { email ->
                event(HomeEvent.SetDataAssistantDialogStatus(email,false))
                event(HomeEvent.SetMoreStatus(false))
                event(HomeEvent.SetInfoStatus(false))
                event(HomeEvent.SetUserFavoriteMessagesStatus(false))
                event(HomeEvent.SetInputBarStatus(true))
            },
            onCancelDataAssistantButtonClick = { email ->
                event(HomeEvent.SetDataAssistantDialogStatus(email,false))
            },
            onGenerateAnswerClick = { email, question, messageHistory, logLanguage, userName, userEmail, userCompanyName ->
                event(
                    HomeEvent.GenerateDataAssistantAnswer(
                        email = email,
                        question = question,
                        messageHistory = messageHistory,
                        logLanguage = logLanguage,
                        userName = userName,
                        userEmail = userEmail,
                        userCompanyName = userCompanyName
                    )
                )
            },
            onFavoriteMessagesButtonClick = {
                event(HomeEvent.SetUserFavoriteMessagesStatus(it))
            },
            onInfoButtonClick = {
                event(HomeEvent.SetInfoStatus(it))
            },
            onMoreButtonClick = {
                event(HomeEvent.SetMoreStatus(it))
            },
            setInputBarVisible = {
                event(HomeEvent.SetInputBarStatus(it))
            },
            onQuestionInputChange = {
                event(HomeEvent.OnChangeAIDataAssistantQuestion(it))
            },
            onFavoriteMessagesChange = { email, messageHistory, favoriteMessages ->
                event(
                    HomeEvent.SaveDataAssistantFavoriteMessages(
                        email = email,
                        messageHistory = messageHistory,
                        favoriteMessages = favoriteMessages
                    )
                )
            },
            getDataAssistantMessageHistory = {
                event(HomeEvent.GetDataAssistantMessageHistory(it))
            },
            profileInfo = state.profileInfo,
            userFavoriteMessagesVisible = state.userFavoriteMessagesVisible,
            logs = state.dataAssistantRequestLogs,
            logLanguage = state.logLanguage,
            freeCredits = state.freeCredits,
            premiumCredits = state.premiumCredits,
            userInfoVisible = state.userInfoVisible,
            moreMenuVisible = state.moreMenuVisible,
            inputBarVisible = state.inputBarVisible
        )
    }


}


